/**
 * Demo line 2802. `BRIDGING` — the four machines standing in for another.
 *
 * Not in `shared/seed/` because the Population scene that owns it is Tier 2
 * and unbuilt; the `bridging_units` intent is its only reader today. It moves
 * to a seed when that scene lands. Re-exported from `./local-answer.ts`.
 *
 * Data Schema layer — pure data.
 */
export const BRIDGING: Readonly<Record<string, string>> = {
  'S-11':
    'Bridging unit — pre-split on the Stage 3 cutback until the second MS-45 is commissioned (Nov)',
  'L-16':
    'Bridging unit — ML-14 covering the northern stopes while L-18 was in repair (07–09 Sep)',
  'L-01': 'Bridging unit — ML-14 on the 280 level while L-02 was flushed (03 Sep)',
  'T-05': 'Bridging unit — on loan from Broken Ridge to Kalbarri Mar–Jun 2026, returned',
};
